import * as React from 'react';
import { Linked, useCollection, useIO, useModel } from '@type-r/react';
import { FormSelect, Option, FormInput, Loading } from 'lqx-react';
import { attributes, Events } from '@type-r/models';
import { SocDialog } from './socDialog';
import { InvoiceModel } from 'api/invoice';
import { Activity } from 'api/activity';
import { localUserInfo } from 'api';

const InternalInvoiceStatus = attributes({
    id: Number,
    internalStatus: String,
    statusDescription: String,
    companyId: String,
});

const LocalState = attributes({
    internalStatusId: String,
    internalStatus: String,
    internalStatusDescription: String
});

export const InternalStatusSocDialog = (props: {
    $isOpen: Linked<boolean>,
    invoices: any
}) => {
    const invoices = props.invoices.models;
    let state = useModel(LocalState);
    let statuses = useCollection.of(InternalInvoiceStatus);
    const invoiceCommentActivity = useModel(Activity);

    const isReady = useIO(async () => {
        if (invoices && invoices.length > 0) {
            let res = await InvoiceModel.getInternalStatusesByCompany(invoices[0].relationship.id);
            statuses.set(res);
        }
    }, []);

    React.useEffect(() => {
        invoiceCommentActivity.$.type.set('InvoiceInternalStatus');
    }, []);

    const getInternalDescription = (internalStatusId) => {
        let statusDescription = '';
        if (internalStatusId) {
            statusDescription = statuses.find(i => i.id == internalStatusId).statusDescription;
            state.internalStatusDescription = statusDescription;
        }
        return statusDescription;
    }

    const savePopupInfo = async () => {
        await saveInternalStatus();
        await saveComment();
    };

    const saveComment = async () => {
        if (invoices && invoices.length) {
            let activities = invoices.map(i => {
                const activity = invoiceCommentActivity.clone();
                activity.type = "InvoiceInternalStatus"
                activity.assetId = i.id;
                activity.relationshipId = localUserInfo.getRelationshipId(i.conversationId);
                return activity;
            });
            await Activity.saveActivities(activities, 'Invoice');
        }
    }

    const saveInternalStatus = async () => {
        const invoicesToBeUpdated = [];

        invoices.forEach((invoice) => (
            invoicesToBeUpdated.push({
                id: state.internalStatusId,
                invoiceId: invoice.id
            })));

        await InvoiceModel.saveInternalInvoicesStatus(invoicesToBeUpdated);
    };

    return <SocDialog
        {...props}
        dialogType="internalStatus"
        doIO={savePopupInfo}
        onSuccess={() => Events.trigger("Soc:internalStatusAdded")}
        isValid={() => state.internalStatusId != '' && state.internalStatusId != null && state.internalStatusId != undefined}
        child={
            isReady ?
                <>
                    {statuses.length > 0 ?
                        <>
                            <FormSelect label="Internal status" $value={state.$.internalStatusId}   >
                                {statuses.map(sr => <Option value={sr.id}>{sr.internalStatus}</Option>)}
                            </FormSelect>
                            <FormInput label="Internal Description" value={getInternalDescription(state.internalStatusId)} />
                        </> :
                        <div>There is no internal statuses available for this relationship</div>
                    }
                </> : < Loading />
        }
    />
}
